export default __webpack_public_path__ + "static/media/615.1e2977aa.png";